export default "__VITE_ASSET__292c851e__"